import React, { useState } from 'react';
import { FaTimes, FaUser, FaEnvelope, FaComment, FaPhone, FaCheckCircle } from 'react-icons/fa';
import './css/CourseInquiryFormPopup.css';
import { contactService } from '../services/contactService';

const CourseInquiry = ({ courseTitle, onClose }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const inquiryData = {
        fullName: formData.fullName,
        email: formData.email,
        phoneNumber: formData.phoneNumber,
        subject: `Course Inquiry: ${courseTitle}`,
        message: formData.message,
        submittedAt: new Date().toISOString(),
        ipAddress: null
      };

      const response = await contactService.create(inquiryData);

      if (response.success) {
        setIsSuccess(true);
        // Auto-close after 3 seconds
        setTimeout(() => {
          onClose();
        }, 5000);
      } else {
        setError(response?.message || 'Failed to send inquiry. Please try again.');
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to send inquiry. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSuccess) {
    return (
      <div className="inquiry-popup-overlay">
        <div className="inquiry-popup-container success-message">
          <FaCheckCircle className="success-icon" />
          <h3>Inquiry Sent Successfully!</h3>
          <p>Thank you for your inquiry about {courseTitle}.</p>
          <p>We'll contact you shortly with more details.</p>
          <button 
            className="success-button" 
            onClick={onClose}
            style={{ marginTop: '20px' }}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="inquiry-popup-overlay">
      <div className="inquiry-popup-container">
        <button className="inquiry-close-btn" onClick={onClose}>
          <FaTimes />
        </button>
        
        <h3>Inquiry About {courseTitle}</h3>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="inquiry-form-group">
            <label><FaUser /> Full Name</label>
            <input 
              type="text" 
              name="fullName" 
              value={formData.fullName} 
              onChange={handleChange} 
              required 
              disabled={isSubmitting}
            />
          </div>
          
          <div className="inquiry-form-group">
            <label><FaEnvelope /> Email</label>
            <input 
              type="email" 
              name="email" 
              value={formData.email} 
              onChange={handleChange} 
              required 
              disabled={isSubmitting}
            />
          </div>
          
          <div className="inquiry-form-group">
            <label><FaPhone /> Phone Number</label>
            <input 
              type="tel" 
              name="phoneNumber" 
              value={formData.phoneNumber} 
              onChange={handleChange} 
              required 
              disabled={isSubmitting}
            />
          </div>
          
          <div className="inquiry-form-group">
            <label><FaComment /> Your Question</label>
            <textarea 
              name="message" 
              value={formData.message} 
              onChange={handleChange} 
              required 
              rows="4"
              disabled={isSubmitting}
            />
          </div>
          
          <button 
            type="submit" 
            className="inquiry-submit-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Send Inquiry'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CourseInquiry;